import * as Yup from 'yup'

const dniFormSchema = Yup.object({
  dni: Yup.string().required('Tienes que especificar tu DNI'),
})

export default dniFormSchema
